module.exports = __webpack_public_path__ + "static/media/vegas-magic.22910888.gif";